export const REDIRECT_INDICATOR = "VALUATION_REPORT_AUTH_REDIRECT";

export type RedirectResponse = {
  redirectType: string;
};

export const isRedirectObject = (data: unknown): data is RedirectResponse => {
  return typeof data === "object" && data !== null && "redirectType" in data;
};
